export default __webpack_public_path__ + "static/media/cupcake.d3514d0f.jpg";